import { render } from "./InspecaoSupervisaoSim_56.vue?vue&type=template&id=4fbe4d50&scoped=true"
import script from "./InspecaoSupervisaoSim_56.vue?vue&type=script&lang=js"
export * from "./InspecaoSupervisaoSim_56.vue?vue&type=script&lang=js"

import "./InspecaoSupervisaoSim_56.vue?vue&type=style&index=0&id=4fbe4d50&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fbe4d50"]])

export default __exports__